export function maxTwoDecimalDigit(x) {
    return Math.floor(x * 100) / 100;
}
